import { DepthFormat, DepthTexture, UnsignedShortType } from "three"
import createSharedCachedFactory from "../../../rx/memo/createSharedCachedFactory"

const useSceneDepthTexture = createSharedCachedFactory((
  // engine: Engine
) => {
  const depthTexture = new DepthTexture(window.innerWidth, window.innerHeight)
  // depthTexture.type = FloatType
  depthTexture.format = DepthFormat
  depthTexture.type = UnsignedShortType
  return depthTexture
})

export default useSceneDepthTexture
